module.exports = __webpack_public_path__ + "img/jesse.0925b5b5.svg";